import React, { useState, useEffect } from 'react';
import {Alert, FlatList,  Text, TextInput, View, ScrollView, Pressable, StyleSheet} from 'react-native';
import mystyles from '../../assets/styles/mystyles';
import {SafeAreaView} from 'react-native-safe-area-context';

const API_BASE_URL = 'https://api.eabu.net';
//
const Dish = ({zip}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {

    const fetchData = async () => {
      try {
        const url = `${API_BASE_URL}/dish/getalldish/`+ zip


        const response = await fetch(url, { // Replace /your_resource with your endpoint
          method: 'GET', // Or POST, PUT, DELETE, etc.
          headers: {
            'Content-Type': 'application/json',
            // Add any other necessary headers (e.g., authorization tokens)
          },
        });
        console.log(response);


        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const json = await response.json();
        setData(json);

      } catch (e) {
        setError(e);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [zip]);

  if (loading) {
    return <Text>Loading...</Text>;
  }

  if (error) {
    return <Text>Error: {error.message}</Text>;
  }
  const  dataObject = JSON.parse(JSON.stringify(data));
  const returnedData = dataObject.Count;
  if (returnedData == 0) {
    return (
      <SafeAreaView>
        <Text>No record found for : {zip}</Text>
      </SafeAreaView>
    )
  }
  else {
    return (
      <SafeAreaView>
        <Text style={mystyles.headerTitle}>
          Eat Well: Services available around the Zip Code: {zip}
        </Text>

        <ScrollView style={{marginTop: 8}} contentContainerStyle={{alignContent: 'center', justifyContent: 'center'}}
                    showsVerticalScrollIndicator={true}>



          {(() => {
            const items = dataObject?.Items ?? [];
            if (items.length > 1) {
              return items.map((item, idx) => (
                  <View
                      key={item?.id ?? String(idx)}
                      style={[mystyles.card, idx % 2 === 1 && mystyles.cardAlt]}
                  >
                    {!!item?.description && (
                        <Text style={mystyles.description}>{item.description}</Text>
                    )}
                    {!!item?.service && (
                        <Text style={mystyles.service}>{item.service}</Text>
                    )}
                  </View>
              ));
            }
            const item = items[0];
            return item ? (
                <View key={item?.id ?? '0'} style={mystyles.card}>
                  {!!item?.description && (
                      <Text style={mystyles.description}>{item.description}</Text>
                  )}
                  {!!item?.service && (
                      <Text style={mystyles.service}>{item.service}</Text>
                  )}
                </View>
            ) : null;
          })()}

        </ScrollView>
      </SafeAreaView>



    )
  }

}


export default Dish;
